import React, { useState } from "react";

export default function ReportPedigree({ pedigree = {} }) {
  const [generations, setGenerations] = useState(3);
  const [highlight, setHighlight] = useState("");
  const [search, setSearch] = useState("");
  const repeatedByClass = new Map();
  Object.values(pedigree)
    .filter((horse) => horse?.class && horse.name)
    .forEach((horse) => {
      const ancestorClass = String(horse.class);
      if (!repeatedByClass.has(ancestorClass)) {
        repeatedByClass.set(ancestorClass, horse.name);
      }
    });
  const repeated = [...repeatedByClass.entries()];
  const repeatedIndexByClass = new Map(
    repeated.map(([ancestorClass], index) => [ancestorClass, index]),
  );
  return (
    <section className="report-panel" id="pedigree">
      <div className="report-section-heading">
        <div>
          <p className="report-eyebrow">Explore the bloodlines</p>
          <h2>Five-generation pedigree</h2>
        </div>
        <label>
          Generations
          <select
            value={generations}
            onChange={(event) => setGenerations(Number(event.target.value))}
          >
            {[3, 4, 5].map((value) => (
              <option key={value}>{value}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="report-toolbar">
        <label>
          Find an ancestor
          <input
            type="search"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Search pedigree names"
          />
        </label>
        <label>
          Highlight repeated ancestor
          <select
            value={highlight}
            onChange={(event) => setHighlight(event.target.value)}
          >
            <option value="">All repeated ancestors</option>
            {repeated.map(([ancestorClass, name]) => (
              <option key={ancestorClass} value={ancestorClass}>
                {name}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div
        className="report-pedigree-scroll"
        tabIndex="0"
        aria-label="Pedigree tree, scroll horizontally to explore"
      >
        <div
          className="report-pedigree"
          style={{
            gridTemplateColumns: `repeat(${generations}, minmax(170px, 1fr))`,
          }}
        >
          {Array.from({ length: generations }, (_, generation) => (
            <div className="report-pedigree__generation" key={generation}>
              <h3>Generation {generation + 1}</h3>
              {Array.from({ length: 2 ** (generation + 1) }, (_, index) => {
                const position = 2 ** (generation + 1) - 1 + index;
                const horse = pedigree[position] || {};
                const ancestorClass = horse.class ? String(horse.class) : null;
                const repeatedIndex = ancestorClass
                  ? repeatedIndexByClass.get(ancestorClass)
                  : null;
                const repeatedColor =
                  repeatedIndex == null
                    ? undefined
                    : {
                        "--ancestor-highlight-background": `hsl(${(repeatedIndex * 360) / repeated.length} 78% 87%)`,
                        "--ancestor-highlight-border": `hsl(${(repeatedIndex * 360) / repeated.length} 56% 49%)`,
                      };
                const highlighted =
                  (highlight
                    ? ancestorClass === highlight
                    : repeatedIndex != null) ||
                  (search &&
                    horse.name?.toLowerCase().includes(search.toLowerCase()));
                return (
                  <div
                    key={position}
                    className={`report-ancestor${highlighted ? " is-highlighted" : ""}${search && !horse.name?.toLowerCase().includes(search.toLowerCase()) ? " is-dimmed" : ""}`}
                    style={repeatedColor}
                  >
                    <strong title={horse.name || "Unknown ancestor"}>
                      {horse.name || "Unknown ancestor"}
                    </strong>
                    <span>
                      {horse.country || "—"}
                      {horse.class ? " · Repeated ancestor" : ""}
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
